import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" && localStorage.getItem("lang");
    if (saved) return saved;
    const nav = typeof navigator !== "undefined" && navigator.language;
    return nav && nav.toLowerCase().startsWith("es") ? "es" : "en";
  });

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("lang", l);
  }, []);

  const t = useCallback(
    (key) => {
      const parts = key.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      if (node === undefined) {
        let fallback = translations.en;
        for (const p of parts) fallback = fallback?.[p];
        return fallback ?? key;
      }
      return node;
    },
    [lang]
  );

  // pick localized value from {en, es} objects
  const L = useCallback(
    (obj) => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj.en || obj.es || "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, L }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
